import { createFileRoute } from '@tanstack/react-router';

import { SessionEndedPageWidget } from '@features/auth/pages/SessionEndedPage';

export const Route = createFileRoute('/auth/end')({
  component: Page,
  validateSearch: (search) => {
    return {
      back: search?.back,
    } as { back?: string };
  },
});

function Page() {
  const search = Route.useSearch();
  return <SessionEndedPageWidget back={search.back} />;
}
